<template>
    <div class="fill-height">

        <v-progress-linear
                :active="inLoading"
                :indeterminate="inLoading"
                absolute
                color="deep-purple-accent-4"
        ></v-progress-linear>

        <v-snackbar color="error" location="top" v-model="snackbarError" :timeout="15000">
            <span>{{ message }}</span>
            <template v-slot:actions>
                <v-btn variant="text" @click="snackbarError = false">{{ $t('close') }}</v-btn>
            </template>
        </v-snackbar>

        <v-snackbar color="success" location="top" v-model="snackbarSuccess" :timeout="15000">
            <span>{{ message }}</span>
            <template v-slot:actions>
                <v-btn variant="text" @click="snackbarSuccess = false">{{ $t('close') }}</v-btn>
            </template>
        </v-snackbar>

        <v-container class="fill-height" fluid>
            <v-row align="center" justify="center">
                <v-col cols="12" sm="8" md="4">
                    <v-card class="elevation-12">

                        <v-card-text>
                            <v-form ref="form" v-model="formValid">
                                <v-text-field
                                        ref="email"
                                        :label="$t('email')"
                                        name="email"
                                        type="text"
                                        variant="outlined"
                                        :rules="emailRules"
                                        required
                                        v-model="email"
                                ></v-text-field>
                                <v-text-field
                                        ref="password"
                                        :label="$t('password')"
                                        name="password"
                                        :type="showPassword ? 'text' : 'password'"
                                        variant="outlined"
                                        :rules="passwordRules"
                                        required
                                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                        @click:append="showPassword = !showPassword"
                                        v-model="password"
                                ></v-text-field>

                                <v-row class="ml-0 mr-0" align="center">
                                    <v-checkbox v-model="remember" class="mt-0" :label="$t('remember')"></v-checkbox>
                                    <v-spacer></v-spacer>
                                    <router-link class="text-subtitle-1" to="/forgot-password">{{ $t('forgotPassword') }}
                                    </router-link>
                                </v-row>

                                <v-btn color="success" style="min-height: 50px" block @click="login()"
                                       :disabled="inProgress || inLoading">
                                    {{ $t('login') }}
                                </v-btn>

                            </v-form>
                        </v-card-text>
                    </v-card>

                    <v-card-text class="text-center">
                        <div class="my-8 text-subtitle-1">
                            <span>{{ $t('dontHaveAccount') }} <router-link to="/registration">{{ $t('register') }}</router-link></span>
                        </div>
                    </v-card-text>

                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>

    import { getCookie, setCookie } from '@/utils/cookie'
    import { sessionStart, sessionSet } from '@/utils/session'
    import api from './backend-api'
    import { useI18n } from 'vue-i18n'
    import { useStore } from 'vuex'

    export default {
        name: 'Login',
        setup() {
            const { t } = useI18n();
            const store = useStore();
            return { t, store };
        },
        data() {
            return {
                email: '',
                password: '',
                showPassword: false,
                remember: false,
                message: '',
                snackbarSuccess: false,
                snackbarError: false,
                inProgress: false,
                inLoading: false,
                formValid: false,
            }
        },
        computed: {
            emailRules() {
                return [
                    v => !!v || this.t('emailRequired'),
                ];
            },
            passwordRules() {
                return [
                    v => !!v || this.t('passwordRequired'),
                ];
            },
        },
        methods: {
            async login() {
                const { valid } = await this.$refs.form.validate();
                if (!valid) return;

                this.inProgress = true;
                this.inLoading = true;

                let deviceId = getCookie('deviceId');
                api.login(this.email, this.password, deviceId)
                    .then(response => {
                        if (response.data.success) {
                            sessionStart();
                            sessionSet('token', response.data.accessToken.token);
                            setCookie('deviceId', response.data.accessToken.deviceId, 730);
                            if (this.remember) setCookie('token', response.data.accessToken.token, 14);
                            this.$router.push('/protected').catch(error => {console.log(error);})
                        } else {
                            this.inProgress = false;
                            this.inLoading = false;
                            this.message = response.data.message;
                            this.snackbarError = true;
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        this.message = this.t('connectionLost');
                        this.snackbarError = true;
                        this.inProgress = false;
                        this.inLoading = false;
                    })
            }
        },
        created() {
            const msg = this.store.getters.message;
            if (msg) {
                this.message = msg;
                this.snackbarSuccess = true;
                this.store.commit('clearMessage');
            }
        }
    }
</script>